import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Form } from '../../models/forms.model';

export interface FormsState {
  formsMap: Record<number, Form[]>;
  currentForm?: Form | null;
}

const initialState: FormsState = {
  formsMap: {},
  currentForm: null,
};

const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    setForms: (state, action: PayloadAction<{ communityId: number; forms: Form[] }>) => {
      const { communityId, forms } = action.payload;
      state.formsMap[communityId] = forms;
    },
    addForm: (state, action: PayloadAction<{ communityId: number; form: Form }>) => {
      const { communityId, form } = action.payload;
      if (!state.formsMap[communityId]) state.formsMap[communityId] = [];
      state.formsMap[communityId].push(form);
    },
    setCurrentForm: (state, action: PayloadAction<Form | null>) => {
      state.currentForm = action.payload;
    },
    updateForm: (state, action: PayloadAction<{ communityId: number; form: Form }>) => {
      const { communityId, form } = action.payload;
      state.formsMap[communityId] = (state.formsMap[communityId] || []).map((f) => (f.id === form.id ? form : f));
    },
    deleteForm: (state, action: PayloadAction<{ communityId: number; formId: string }>) => {
      const { communityId, formId } = action.payload;
      state.formsMap[communityId] = (state.formsMap[communityId] || []).filter((f) => f.id !== formId);
    },
  },
});

export const { setForms, addForm, setCurrentForm, updateForm, deleteForm } = formsSlice.actions;
export default formsSlice.reducer;
